export default "__VITE_ASSET__ELO0b6mB__"